(function() {
    'use strict';

    angular
        .module('app')
        .controller('ListMusiciansController', ListMusiciansController);

    ListMusiciansController.$inject = ['$state' ,'$stateParams', '$scope', '$http', 'dialog'];

    function ListMusiciansController($state, $stateParams, $scope, $http, dialog) {
        var vm = this;
        vm.state = $state;
        vm.checkLanguage = checkLanguage;
        vm.reactivateProfile = reactivateProfile;

        vm.editMusician = function (e, musician) {
            e.preventDefault();
            e.stopPropagation();
            $state.go('edit_musician', {band_slug: musician.band_slug});
        }

        function reactivateProfile(e, musician) {
             $http.patch('api/band/deactivated_status/' + musician.band_slug + '/false/')
                .then(function (response) {
                    musician.band_deactivated_at = null;
                    $scope.$applyAsync();
                    dialog.info('profile-reactivated-info');
                });
        }

        function checkLanguage(genres){
            if($stateParams.language == 'da'){
                 return genres ? genres.replace("Classical", "Klassisk") : '';
            }
            return genres;
        }
    }
})();
